import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import axios from 'axios';
import { setHeader } from '../services/Headers';
import { Url } from '../services/Constants';

export default function OrderDetails({data}) {

  const [user,setUser] = useState()


  useEffect(()=>{
    const getUser = async()=>{
       const result = await axios.get(`${Url}/buyer/get_profile`,setHeader())
       if(result.data.response_code===200){
        setUser(result.data.response_data)
      }
    }
    
    getUser()
  },[])
  


  return (
      <div className="order-feed py-2 relative bg-red-50 w-full mx-auto rounded-2xl -z-10 mb-10 shadow-lg">
        <div className="feed-container w-[96%] mt-[2%] mb-[1%] mx-auto">
          <div className="order-detail-container bg-white p-[2%] shadow-xl rounded-2xl">
            <div className="order-id w-full border-b-2 text-right mb-[2%]"> Order Id: {data.order_id}</div>
            <div className="order-details w-full flex flex-col sm:flex-row border-b-2 pb-[2%]">
              <div className="left w-full sm:w-[40%] flex cursor-pointer group mb-4 sm:mb-0">
                <img src={data.product_images[0].image} alt="product-image" className="w-full h-full group-hover:opacity-50" />
              </div>
              <div className="right ml-0 sm:ml-[1.5%] w-full">
                <div className="product-name full text-amber-950 flex justify-between cursor-default">
                  <span className="product-name text-xl sm:text-2xl font-bold cursor-pointer">{data.product_name}</span>
                </div>
                <div className="product-category my-[2%]">
                  <span className="text-amber-950 text-lg font-bold">Category:{" "}</span>
                  <span className="text-amber-950">{data.category_name}</span>
                </div>
                <div className="product-specification w-full sm:w-[75%] text-[85%] my-[2%] text-amber-950 cursor-default">
                  {data.specification}
                </div>
                <div className="price-container flex items-end cursor-default justify-between"> 
                  <div className="price">
                    <span className="text-amber-950 font-bold text-lg">Rs. {data.product_variant_discounted_price}</span>                
                  </div>
                  <div className="qty text-amber-950">
                    <span className="quantity">Qty:- {data.quantity}</span>
                  </div>                              
                </div>
              </div>
            </div>
            <div className="order-track w-full py-[10%] flex flex-col justify-center border-b-2">
              <div className="track flex items-center justify-center">
                <div className="confirmed bg-amber-950 rounded-full p-[1%]">
                  <img src="../assets/order_confirmed.png" alt="confirmed-icon" className="order-confirmed" />
                </div>
                <div className={data.order_deatails.order_status==="In Transit" || data.order_deatails.order_status === "Delivered"?"line border-amber-950 border-b-8 w-[20%]":"line border-amber-950 border-b-2 w-[20%]"}></div>
                <div className={data.order_deatails.order_status==="In Transit" || data.order_deatails.order_status === "Delivered"?"shipped bg-amber-950 rounded-full p-[1%]":"shipped p-[1%] border border-amber-950 rounded-full"}>
                  <img src="../assets/order_shipped.png" alt="shipped-icon" className={data.order_deatails.order_status==="In Transit" || data.order_deatails.order_status === "Delivered"?"order-shipped":"invert"} />
                </div>
                <div className={data.order_deatails.order_status==="Delivered"?"line border-amber-950 border-b-8 w-[20%]":"line border-amber-950 border-b-2 w-[20%]"}></div>
                <div className={data.order_deatails.order_status==="Delivered"?"delivered bg-amber-950 rounded-full p-[1%]":"delivered p-[1%] border border-amber-950 rounded-full"}>
                  <img src="../assets/delivered.png" alt="delivered-icon" className={data.order_deatails.order_status==="Delivered"?"order-delivered invert":""} />
                </div>
              </div>
              <div className="track-btn w-[70%] sm:w-[15%] py-[0.8%] bg-amber-950 cursor-pointer rounded-md mt-[3%] text-white text-center mx-auto hover:bg-amber-900">Track Order</div>
            </div>
                        <div className="address-and-price bg-slate-100 rounded-lg mb-[3%] flex flex-col sm:flex-row p-[3%] justify-around border-b-2">
              <div className="address text-center w-full sm:w-[45%] mb-4 sm:mb-0">
                <div className="top text-lg text-amber-950 font-bold border-b-2 mb-[3%] border-b-amber-950">Delivery Address</div>
                <div className="bottom flex flex-col text-amber-950">
                  <span className="name font-bold my-[2%]">{user?.name}</span>
                  <span className="number my-[2%]">+{user?.mobile_code}{" "}{user?.mobile_number} </span>
                  <span className="address my-[2%] w-[90%] mx-auto">{data.order_shipping_address.street_address}, {data.order_shipping_address.city}, {data.order_shipping_address.state} - {data.order_shipping_address.pincode}</span>
                </div>
              </div>
              <div className="price text-center w-full sm:w-[45%]">
                <div className="top text-lg text-amber-950 font-bold border-b-2 mb-[3%] border-b-amber-950">Price Details</div>
                <div className="center w-[90%] mx-auto text-amber-950 border-b-2 border-b-gray-400">
                  <div className="list-price flex justify-between my-[3%]">
                    <span className="title">List Price</span>
                    <span className="number">{data.product_variant_price}</span>
                  </div>
                  <div className="selling-price flex justify-between my-[3%]">
                    <span className="title">Selling Price</span>
                    <span className="number">{data.product_variant_discounted_price}</span>
                  </div>
                  <div className="discount-price flex justify-between my-[3%]">
                    <span className="title">Discount Price</span>
                    <span className="number">{data.product_variant_price-data.product_variant_discounted_price}</span>
                  </div>
                  <div className="gst flex justify-between my-[3%]">
                    <span className="title">GST</span>
                    <span className="number">{data.gst}%</span>
                  </div>
                </div>
                <div className="bottom flex font-bold justify-between w-[90%] text-amber-950 mx-auto my-[4%]">
                  <span className="title">Total Price</span>
                  <span className="number">{data.order_deatails.grand_total_price}</span>
                </div>
              </div>
            </div>     
          </div>
        </div>
        <div className="feed-bottom bg-amber-950 w-[96%] mx-auto text-white p-[2%] flex flex-col sm:flex-row">
          <div className="left w-full sm:w-[85%] mb-4 sm:mb-0">
            <span className="block">Did you encounter any difficulties during your shopping process?</span>
            <span className="block">Let us know your questions.</span>
          </div>
          <div className="right w-full sm:w-[15%] flex mx-auto justify-around">
            <img src="../assets/help.png" alt="help-icon" className="cursor-pointer" />
            <img src="../assets/msg.png" alt="message-icon" className="cursor-pointer" />
          </div>
        </div>
      </div>
  );
}